import twMerge from 'utils/twMerge';

type AccessibleLinkProps = {
    title: string;
    href: string;
};

export const AccessibleLink: FC<AccessibleLinkProps> = ({ title, href, className }) => {
    return (
        <a
            href={href}
            tabIndex={0}
            className={twMerge(
                'sr-only focus:not-sr-only focus:absolute focus:left-0 focus:top-0 focus:block focus:w-full focus:p-2',
                'z-aboveOverlay w-full bg-blueVeryLight p-2 text-center text-body font-semibold no-underline',
                className,
            )}
        >
            {title}
        </a>
    );
};
